module.exports = __webpack_public_path__ + "img/holiday_2_bali.179d877b.jpg";